<template>
  <qx-card title="合作车队列表">
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          ></el-table-column>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column prop="control" label="操作" fixed="right">
            <template slot-scope="scope">
              <section>
                <!-- 操作按钮 -->
                <qx-permpisions permpisions="1400205" v-if="scope.row.vehicleClass !== 1">
                  <span class="primary cur" @click="doRemove(scope.row)">解除合作</span>
                </qx-permpisions>
                <!-- 操作按钮 end -->
              </section>
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {
  doQueryTenantByVehicleCode,
  dissolveCooperationVehicle,
} from 'api/car';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'plateNumber',
            label: '车队名称',
          },
          {
            prop: 'applyVehicleClassName',
            label: '车队联系人',
          },
          {
            prop: 'tenantName',
            label: '车队联系电话',
          },
          {
            prop: 'linkPhone',
            label: '车辆种类',
          },
          {
            prop: 'beApplyDriverMobile',
            label: '加入时间',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: doQueryTenantByVehicleCode,
    doRemove (item) {
      const vehicleCode = this.$route.query.id;
      this.$confirm(`确认解除与[${item.tenantName}]车队的合作关系？解除后对方将无法调用该车辆。`, '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        await dissolveCooperationVehicle({
          relId: item.relId,
          vehicleCode,
        });
        this.$message({
          type: 'success',
          message: '操作成功!',
        });
        this.getData();
      }).catch(() => {
        console.log('操作取消');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
